{
  "id": "campaign-028",
  "name": "Daisy Park",
  "seed": "campaign:28",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....._.....#",
    "....n_.n.sss",
    "....._...sss",
    "*...._.....*",
    "*...._.....*",
    "*...._.....*",
    "..,.._......",
    ".,,.n_.n.x..",
    "..,.._......",
    "....._......",
    "....._......",
    "....h_.h....",
    "....._......",
    "....._......",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 1,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 13
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 5,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 4
    },
    {
      "kind": "rare",
      "x": 5,
      "y": 2
    },
    {
      "kind": "repair",
      "x": 1,
      "y": 2
    }
  ],
  "generatorVersion": 3,
  "level": 28,
  "biome": "park",
  "par": {
    "reel": 6214,
    "push": 5332,
    "selfPropelled": 4848,
    "tractor": 4520,
    "zeroTurn": 3403,
    "fairway": 1932
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 23
    }
  }
}
